import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedUiVideoPlayerComponent } from './shared-ui-video-player.component';

@NgModule({
  imports: [CommonModule],
  declarations: [SharedUiVideoPlayerComponent],
  exports: [SharedUiVideoPlayerComponent],
})
export class SharedUiVideoPlayerModule {}
